"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
const react_1 = __importDefault(require("react"));
const class_variance_authority_1 = require("class-variance-authority");
const utils_1 = require("../utils");
const tagVariants = (0, class_variance_authority_1.cva)("inline-block rounded-[100px] px-4 py-2 text-[14px] flex items-center space-x-2", {
    variants: {
        variant: {
            primary: "bg-blue-100 text-blue-700",
            secondary: "bg-grey300 text-brandBlack",
            success: "bg-brandSecondary text-brandWhite",
            danger: "bg-red-100 text-red-700",
        },
    },
    defaultVariants: {
        variant: "primary",
    },
});
const Tag = ({ children, variant, className, inIcon, ...rest }) => {
    return (react_1.default.createElement("button", { className: (0, utils_1.cn)(tagVariants({ variant }), className), ...rest },
        inIcon && typeof inIcon === "string" ? (react_1.default.createElement("img", { src: inIcon, alt: "icon", className: "mr-2 w-4 h-4" })) : (inIcon),
        children));
};
exports.Tag = Tag;
